import { deleteArtTemporada, postArtTemporada,getArtTemporadasPanel } from "../../services/ArticulosTemporadasServices";
import { ArticulosTemporadasContext } from "./ArticulosTemporadasContext"

export const ArticulosTemporadasState = ({ children }) => {
    const getArtTemporadasPanelData = async (searchRam,searchTerm, page, perPage) => {
        let res = await getArtTemporadasPanel(searchRam,searchTerm, page, perPage)
        return res;
    }

    const deleteArticuloTemporadaData = async (body) => {
        const res = await deleteArtTemporada(body)
        return res
    }

    const postArticuloTemporadaData = async (body) => {
        const res = await postArtTemporada(body)
        return res
    }
    return <ArticulosTemporadasContext.Provider value={{
        deleteArticuloTemporadaData,
        postArticuloTemporadaData,
        getArtTemporadasPanelData

    }} >
        {children}
    </ArticulosTemporadasContext.Provider>
}